import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "";

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const fetchPortfolio = (category) => {
    if (!API) return Promise.resolve([]);
    return api
        .get(`/portfolio${category && category !== "all" ? `?category=${category}` : ""}`)
        .then((r) => r.data);
};

export const fetchReviews = () => {
    if (!API) return Promise.resolve([]);
    return api.get(`/reviews`).then((r) => r.data);
};

export const createBooking = (payload) => {
    if (!API) return Promise.resolve({ ok: true });
    return api.post(`/bookings`, payload).then((r) => r.data);
};
